import { render, staticRenderFns } from "./CallerIdListCreateOrEditFromDedicatedNumber.vue?vue&type=template&id=57128562&scoped=true&"
import script from "./CallerIdListCreateOrEditFromDedicatedNumber.vue?vue&type=script&lang=js&"
export * from "./CallerIdListCreateOrEditFromDedicatedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57128562",
  null
  
)

export default component.exports